/** Classify native GPU validation text locally; never retain or upload that text. */
export function classifyMobileWebGpuValidation(message: unknown): string {
  if (typeof message !== 'string') return 'unclassified';
  if (/fewer output components/i.test(message)) return 'fragment-output-components';
  if (/multisampled flag.*match|sample.?count.*(?:match|differ|incompat)/i.test(message)) return 'multisample-mismatch';
  if (/float32-blendable|(?:rgba?32float|r32float).*blend/i.test(message)) return 'float32-blending';
  if (/maxBufferSize|minBindingSize|buffer.*(?:size|offset|range).*(?:exceed|large|small|align|bounds)/i.test(message)) return 'buffer-size-or-offset';
  if (/bind.?group|binding.*layout/i.test(message)) return 'binding-layout';
  if (/texture.*(?:usage|format|invalid)|format.*(?:renderable|unsupported|not supported)/i.test(message)) return 'texture-usage-or-format';
  if (/invalid.*render.?pipeline|render.?pipeline.*invalid/i.test(message)) return 'invalid-render-pipeline';
  if (/entry.?point.*(?:missing|not found|does not exist)|(?:missing|not found).*entry.?point/i.test(message)) return 'shader-entry-point';
  if (/shader.*(?:compil|pars)|(?:compil|pars).*shader/i.test(message)) return 'shader-compilation';
  if (/shader|pipeline/i.test(message)) return 'shader-or-pipeline';
  return 'unclassified';
}
